import React from 'react';

import { Button } from '~/components';

const ButtonLinkFileManagerLinkAnexo = ({
  children,
  onClick,
  disabled = false,
}) => (
  <Button
    onClick={onClick}
    type="link"
    block
    disabled={disabled}
    style={{
      wordWrap: 'anywhere',
      whiteSpace: 'normal',
      textAlign: 'left',
    }}
  >
    {children}
  </Button>
);

export default ButtonLinkFileManagerLinkAnexo;
